import React from 'react';
import WarningIcon from '../../containers/WarningIcon';

const NoPermissionMessage = () => (
  <div className="no-study-message">
    <WarningIcon />
    <p>Sorry, You {"don't"} have enough permission to view this page.</p>
  </div>
);

export default NoPermissionMessage;
